import { combineReducers } from 'redux';
import listReducer from './list/reducer';
import redirectingToReducer from './redirectingTo/reducer';
import loaderReducer from './loader/reducer';
import { LIST_STATE_NAME, REDIRECTING_TO_STATE_NAME, LOADER_STATE_NAME } from './constants';

export default combineReducers({
  [LIST_STATE_NAME]: listReducer,
  [REDIRECTING_TO_STATE_NAME]: redirectingToReducer,
  [LOADER_STATE_NAME]: loaderReducer,
});



// WEBPACK FOOTER //
// ./app/Sources/reducer.js